import './Button.css';

import clsx from 'clsx';
import React from 'react';

interface Props {
  className?: string;
  color?: Colors;
  paddingMode?: PaddingMode;
  href?: string;
  target?: string;
  type?: StyleType;
  rightContent?: string;
  leftContent?: string;
  arrowLeft?: string;
  arrowRight?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  disabled?: boolean;
}

export const Button: React.FC<Props> = props => {
  const {
    className = '',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    type = StyleType.TYPE_ROUNDED,
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    color = Colors.COLOR_SCHEME_1,
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    paddingMode = PaddingMode.PADDING_MODE_4,
  } = props;
  const createClassName = `Button Transition 
    ${className} ${type.toString()} 
    ${color.toString()} ${paddingMode.toString()} 
    ${clsx({ Disabled: props.disabled })}`;

  return (
    <div className={props.className}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div className={createClassName} onClick={props.onClick}>
        {props.children}
      </div>
    </div>
  );
};

export enum Colors {
  COLOR_SCHEME_1 = 'ColorScheme1',
  COLOR_SCHEME_2 = 'ColorScheme2',
  COLOR_SCHEME_3 = 'ColorScheme3',
  COLOR_SCHEME_4 = 'ColorScheme4',
  COLOR_SCHEME_5 = 'ColorScheme5',
  COLOR_SCHEME_6 = 'ColorScheme6',
  COLOR_SCHEME_7 = 'ColorScheme7',
  COLOR_SCHEME_8 = 'ColorScheme8',
  COLOR_SCHEME_9 = 'ColorScheme9',
  COLOR_SCHEME_10 = 'ColorScheme10',
  COLOR_SCHEME_11 = 'ColorScheme11',
  COLOR_SCHEME_12 = 'ColorScheme12',
  COLOR_SCHEME_13 = 'ColorScheme13',
}

export enum PaddingMode {
  PADDING_MODE_1 = 'NoPadding',
  PADDING_MODE_2 = 'Narrow',
  PADDING_MODE_3 = '',
  PADDING_MODE_4 = 'LargePadding',
  WIDTH_135 = 'width135',
  PADDING_MODE_5 = 'fullwidth_add_btn',
}

export enum StyleType {
  TYPE_ROUNDED = 'ButtonRounded',
  TYPE_TEXT_INLINE = 'ButtonTextInline',
}

Button.defaultProps = {
  className: '',
  color: Colors.COLOR_SCHEME_1,
  paddingMode: PaddingMode.PADDING_MODE_3,
  type: StyleType.TYPE_ROUNDED,
  href: '',
  target: '',
  rightContent: '',
  leftContent: '',
  arrowLeft: '',
  arrowRight: '',
  disabled: false,
};
